import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 35 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M0 11.032C0 18.333 2.758 22 8.241 22c3.095 0 5.315-1.168 6.492-3.245 1.211-2.076 1.682-4.478 1.682-7.723s-.471-5.71-1.682-7.787C13.556 1.168 11.336 0 8.241 0 2.758 0 0 3.667 0 11.032m4.71 0q0-6.62 3.531-6.619c2.321 0 3.465 2.206 3.465 6.62 0 4.38-1.144 6.554-3.465 6.554-2.354 0-3.532-2.174-3.532-6.555m29.686 6.36H27.6l5.079-5.548C34.226 10.156 35 8.372 35 6.457c0-1.882-.706-3.44-2.12-4.64C31.503.617 29.787 0 27.803 0c-4.138 0-7.03 2.531-7.703 6.587l4.305.714c.27-1.72 1.48-2.953 3.128-2.953 1.716 0 2.759.941 2.759 2.11 0 .746-.404 1.524-1.178 2.4L20.066 19.21v2.467h14.33z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }